module.exports = __webpack_public_path__ + "static/media/freezerRoom.b309a747.svg";